// Traductions du namespace `js:` des locales Rails, injectées par les layouts dans
// `window.jsTranslations`. Évite de faire voyager des libellés par des data-attributes.
//
//   t("composition_editor.layers.title")
export function t(path, fallback = "") {
  const value = path.split(".").reduce((node, key) => node?.[key], window.jsTranslations);

  return typeof value === "string" ? value : fallback;
}
